<div *ngIf="!isEconConfirmedOrder && !isAtHomeOrder">
<div class="modal-header customBlueHeader" >
    <p class="modal-title">Mark Order as Complated</p>
    <button type="button" class="close" aria-label="Close" (click)="modelClose()">
      <span aria-hidden="true">&times;</span>
    </button>
</div>
  <div [ngClass]="{'succMsg': isSuccessMsg, 'errMsg': isFailureMsg}"><b>{{msg}}</b></div>
  <div class="modal-body customModalBody">
    <p>Are you sure, you want to complete this test?</p>

  </div>
  <div class="modal-footer customModalFooter">
    <button type="button" class="btn danger_btn" (click)="modelClose()">Cancel</button>

    <button type="button" class="btn green_btn" (click)="confirmItem()">Completed</button>
  </div>
</div>

<div *ngIf="isEconConfirmedOrder && !isAtHomeOrder">
<div class="modal-header customBlueHeader" >
    <p class="modal-title">Mark Order as Confirm</p>
    <button type="button" class="close" aria-label="Close" (click)="modelClose()">
      <span aria-hidden="true">&times;</span>
    </button>
</div>
  <div [ngClass]="{'succMsg': isSuccessMsg, 'errMsg': isFailureMsg}"><b>{{msg}}</b></div>
  <div class="modal-body customModalBody">
    <p>Are you sure, you want to confirm the order ?</p>

  </div>
  <div class="modal-footer customModalFooter">
    <button type="button" class="btn danger_btn" (click)="modelClose()">Cancel</button>

    <button type="button" class="btn green_btn" (click)="confirmEconOrder()">Confirm</button>
  </div>
</div>

<div *ngIf="!isEconConfirmedOrder && isAtHomeOrder">
<div class="modal-header customBlueHeader" >
    <p class="modal-title">{{headerText}}</p>
    <button type="button" class="close" aria-label="Close" (click)="modelClose()">
      <span aria-hidden="true">&times;</span>
    </button>
</div>
  <!--<div [ngClass]="{'succMsg': isSuccessMsg, 'errMsg': isFailureMsg}"><b>{{msg}}</b></div>-->
  <div class="modal-body customModalBody">
    <p>{{bodyText}}</p>

  </div>
  <div class="modal-footer customModalFooter">
    <button type="button" class="btn danger_btn" (click)="modelClose()">Cancel</button>

    <button type="button" class="btn green_btn" (click)="confirmAtHomeOrder()">Confirm</button>
  </div>
</div>